import { render, staticRenderFns } from "./grayConfig.vue?vue&type=template&id=3800f99f&scoped=true&"
import script from "./grayConfig.vue?vue&type=script&lang=js&"
export * from "./grayConfig.vue?vue&type=script&lang=js&"
import style0 from "./grayConfig.vue?vue&type=style&index=0&id=3800f99f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800f99f",
  null
  
)

export default component.exports